import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import { Button } from "antd";

export const initFilterInput = {
  searchName: "",
  page: 1,
  pageSize: 10,
  transactionStartDate: null,
  transactionEndDate: null,
};

export const addPengembalianData = {
  gadai_id: "",
  sbg: "",
  ktpPenerima: "",
  ktpNasabah: "",
};

export const accType = [
  { label: "Diterima oleh nasabah", value: true },
  // { label: "Jemput Gadai", value: "pick_up" },
];

export const renderColumns = (handleDetail) => {
  return [
    {
      dataIndex: "tanggal_kirim",
      key: "tanggal_kirim",
      title: "Tanggal & Waktu Kirim",
    },
    {
      dataIndex: "no_sbg",
      key: "no_sbg",
      title: "Kode Gadai",
    },
    {
      dataIndex: "nama_nasabah",
      key: "nama_nasabah",
      title: "Nama Nasabah",
    },
    {
      dataIndex: "nama_kurir",
      key: "nama_kurir",
      title: "Nama Kurir",
    },
    {
      dataIndex: "no_telp_nasabah",
      key: "no_telp_nasabah",
      title: "No. Telepon Nasabah",
    },
    {
      dataIndex: "no_telp_kurir",
      key: "no_telp_kurir",
      title: "No. Telepon Kurir",
    },
    {
      dataIndex: "barang_jaminan",
      key: "barang_jaminan",
      title: "Barang Jaminan ",
    },
    {
      dataIndex: "lokasi",
      key: "lokasi",
      title: "Lokasi Barang",
    },
    {
      dataIndex: "lokasi_kirim",
      key: "lokasi_kirim",
      title: "Lokasi Kirim",
      width: "16%",
    },
    {
      dataIndex: "status",
      key: "status",
      title: "Status",
      width: "7%",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "8%",
      render: (_, record) => (
        <div div className="d-flex flex-column">
          <div className="mr-2 mb-2">
            <Button
              variant="primary"
              className="btn-action btn-default font-weight-semi-bold border-2C465C"
              onClick={() => handleDetail(record)}
              style={{ width: "122px" }}
            >
              Detail
            </Button>
          </div>
        </div>
      ),
    },
  ];
};
